export default __webpack_public_path__ + "static/media/map.a2382712.jpg";